import { NgIf, CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';

import { HideMissingDirective } from '../Directives/AppHideMissingFile.directive';

import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatChipsModule } from '@angular/material/chips';

@Component({
  selector: 'app-media-viewer',
  templateUrl: './media-viewer.component.html',
  styleUrls: ['./media-viewer.component.scss'],
  standalone: true,
  imports: [CommonModule,NgIf,MatDialogModule,MatIconModule,MatButtonModule,MatTableModule,MatTabsModule,MatPaginatorModule,MatSortModule,MatCheckboxModule,MatMenuModule,MatSelectModule,
    MatInputModule,MatOptionModule,MatToolbarModule,MatFormFieldModule,MatAutocompleteModule,MatChipsModule,NgxMatSelectSearchModule,HideMissingDirective],

})
export class MediaViewerComponent {
  files: MediaFile[];
  index: number;
  isFullscreen = true;
  updated_files: MediaFile[];
  constructor(
    public dialogRef: MatDialogRef<MediaViewerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { files: MediaFile[], startIndex: number }
  ) {
    this.files = data.files;
    this.index = data.startIndex;
    this.validateFiles(data.files).then(validFiles => {
      this.files = validFiles;
      this.updated_files = validFiles;
      // If no valid files remain → close dialog
      if (this.files.length === 0) {
        this.dialogRef.close();
        return;
      }

      // Adjust index if original startIndex is out of bounds
      this.index = Math.min(data.startIndex, this.files.length - 1);
    });
    //this.files = data.files;
    //this.index = data.startIndex;
    //this.toggleFullscreen();
  }
  ngAfterViewInit() {
    //this.toggleFullscreen();
  }
  get currentFile(): MediaFile {
    return this.files[this.index];
  }

  next() {
    this.index = (this.index + 1) % this.files.length;
  }

  prev() {
    this.index = (this.index - 1 + this.files.length) % this.files.length;
  }

  select(idx: number) {
    this.index = idx;
  }

  close() {
    this.dialogRef.close();
  }
  toggleFullscreen() {
    const viewer = document.querySelector('.viewer') as HTMLElement;
    viewer.classList.toggle('fullscreen-mode');
  }
  private async validateFiles(files: MediaFile[]): Promise<MediaFile[]> {
    const checks = await Promise.all(
      files.map(async f => {
        if (f.type === 'image') {
          return f;
          //return (await this.checkImage(f.path)) ? f : null;
        }
        if (f.type === 'audio' || f.type === 'video') {
          return (await this.checkMedia(f.path, f.type)) ? f : null;
        }
        return null;
      })
    );
    return checks.filter((f): f is MediaFile => f !== null);
  }

  private checkImage(src: string): Promise<boolean> {
    return new Promise(resolve => {
      const img = new Image();
      img.src = src;

      img.onload = () => resolve(true);
      img.onerror = () => resolve(false);

      // Safety timeout
      setTimeout(() => resolve(false), 5000);
    });
  }

  //private checkMedia(src: string, type: string): Promise<boolean> {
  //  return new Promise(resolve => {
  //    const media = document.createElement(type) as HTMLMediaElement;
  //    media.src = src;
  //    media.preload = 'metadata';

  //    const cleanup = () => media.remove();

  //    media.onloadedmetadata = () => { cleanup(); resolve(true); };
  //    media.onerror = () => { cleanup(); resolve(false); };

  //    setTimeout(() => { cleanup(); resolve(false); }, 5000);
  //  });
  //}
  checkMedia(src: string, type: "video" | "audio"): Promise<boolean> {
    return new Promise(resolve => {
      const media = document.createElement(type) as HTMLMediaElement;
      media.src = src;
      media.preload = "metadata";
      media.style.display = "none"; // hide it
      document.body.appendChild(media);

      const cleanup = () => media.remove();

      const successHandler = () => {
        cleanup();
        resolve(true);
      };

      const errorHandler = () => {
        cleanup();
        resolve(false);
      };

      // Browser can start playing the file without interruption
      media.oncanplaythrough = successHandler;

      // Triggered if file cannot be loaded or is corrupted
      media.onerror = errorHandler;

      // Safety timeout for slow loading (e.g., large files)
      setTimeout(() => {
        if (media.readyState < 3) { // HAVE_FUTURE_DATA = 3
          errorHandler();
        }
      }, 300000); // 30 seconds, adjust as needed
    });
  }

  removeFile(i: number) {
    if (i >= 0 && i < this.updated_files.length) {
      this.updated_files.splice(i, 1);
      this.files = this.updated_files;
      if (this.updated_files.length === 0) {
        this.dialogRef.close();
        return;
      }

      // adjust index if it goes out of range
      if (this.index >= this.updated_files.length) {
        this.index = this.updated_files.length - 1;
      }
    }
  }
}

interface MediaFile {
  path: string;
  type: string; // 'image' | 'video' | 'audio' | 'pdf' | 'other'
}

